import { render, staticRenderFns } from "./pinned_links.vue?vue&type=template&id=af7c0250"
import script from "./pinned_links.vue?vue&type=script&lang=js"
export * from "./pinned_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports